import { ShieldCheck, HeartHandshake, Target, Users, FileCheck, Sparkles } from "lucide-react";
import { PROCESS_STEPS } from "../data/content";

const REASONS = [
  { icon: FileCheck, title: "Accompagnement administratif complet", desc: "Nous montons vos dossiers MaPrimeRénov', CEE et aides locales de A à Z." },
  { icon: Target, title: "Optimisation maximale des aides", desc: "Nous cumulons toutes les aides disponibles pour minimiser votre reste à charge." },
  { icon: Users, title: "Installateurs qualifiés RGE", desc: "Notre équipe est certifiée RGE, QualiPAC et Qualibat." },
  { icon: Sparkles, title: "Étude personnalisée", desc: "Chaque projet est étudié par nos experts thermiciens sur mesure." },
  { icon: HeartHandshake, title: "Devis 100% gratuit", desc: "Aucun engagement. Un devis clair, transparent, sans mauvaise surprise." },
  { icon: ShieldCheck, title: "Suivi et garanties", desc: "10 ans de garantie décennale + accompagnement SAV sur la durée." },
];

export default function WhyChooseUs() {
  return (
    <section data-testid="why-us-section" className="relative section-padding bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5 lg:sticky lg:top-28 lg:self-start">
          <div className="eyebrow">Pourquoi Optimeo Habitat</div>
          <h2 className="font-display uppercase text-white text-4xl md:text-5xl lg:text-6xl mt-4 leading-[0.95] tracking-tight">
            Un partenaire<br/>
            <span className="text-[#7DD923]">de confiance</span><br/>
            de A à Z
          </h2>
          <p className="text-white/70 mt-6 leading-relaxed">
            Notre mission : rendre la rénovation énergétique <strong className="text-white">simple, rentable et accessible</strong> pour toutes les familles alsaciennes.
          </p>
          <div className="mt-8 flex flex-wrap gap-6">
            {[
              { n: "+320", l: "Clients Alsace" },
              { n: "98%", l: "Satisfaction" },
              { n: "11 000€", l: "Aides moyennes" },
              { n: "10 ans", l: "Garantie" },
            ].map((s) => (
              <div key={s.l}>
                <div className="font-display text-3xl text-[#7DD923]">{s.n}</div>
                <div className="text-white/50 text-xs uppercase tracking-widest">{s.l}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="grid sm:grid-cols-2 gap-4">
            {REASONS.map(({ icon: Icon, title, desc }, i) => (
              <div
                key={title}
                data-testid={`reason-card-${i}`}
                className="bg-[#121212] border border-white/5 rounded-2xl p-6 hover:border-[#7DD923]/40 transition-colors group"
              >
                <div className="w-10 h-10 rounded-full bg-[#7DD923]/10 border border-[#7DD923]/30 flex items-center justify-center mb-4 group-hover:bg-[#7DD923] group-hover:border-[#7DD923] transition-all">
                  <Icon className="w-5 h-5 text-[#7DD923] group-hover:text-black transition-colors" />
                </div>
                <h3 className="text-white font-semibold text-lg leading-snug">{title}</h3>
                <p className="text-white/60 text-sm mt-2 leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function ProcessTimeline() {
  return (
    <section data-testid="process-timeline" className="relative section-padding bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-16 max-w-2xl">
          <div className="eyebrow">Notre processus</div>
          <h2 className="font-display uppercase text-white text-4xl md:text-5xl lg:text-6xl mt-4 leading-[0.95] tracking-tight">
            De l'étude au<br/>suivi, <span className="text-[#7DD923]">6 étapes</span> claires
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-white/10 to-transparent md:-translate-x-1/2" />
          <div className="space-y-8">
            {PROCESS_STEPS.map((s, i) => (
              <div
                key={s.n}
                data-testid={`process-step-${s.n}`}
                className={`relative flex md:items-center gap-6 md:gap-12 ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}
              >
                <div className="hidden md:block flex-1" />
                <div className="absolute left-4 md:left-1/2 md:-translate-x-1/2 w-3 h-3 rounded-full bg-[#7DD923] shadow-[0_0_0_6px_rgba(125,217,35,0.15)]" />
                <div className="pl-12 md:pl-0 md:flex-1">
                  <div className="glass rounded-2xl p-6 md:p-8 hover:border-[#7DD923]/40 transition-colors">
                    <div className="font-display text-[#7DD923] text-2xl">{s.n}</div>
                    <h3 className="text-white font-semibold text-xl mt-1">{s.title}</h3>
                    <p className="text-white/60 mt-2 text-sm leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
